import { gql } from 'react-apollo';
import { full } from '../../../../graphql/fragments/user';

export const createToken = gql`
  mutation createToken($input: CreateUserTokenInput!) {
    createToken(input: $input) {
      token
      current_user {
        ...allUserFields
      }
    }
  }

  ${full}
`;



// WEBPACK FOOTER //
// ./src/components/pages/login/mutations/createToken.js